import styled from '@emotion/styled';

/**
 * Shared styles
 */

export const FullWidth = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const ReducedRow = styled.div`
  position: relative;
  max-width: 1200px;
  margin: auto;

  .logo-atl {
    display: block;
    margin: 26px auto 26px;
  }
`;
